import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRouterModule } from '@app/router.module';

import { OrganizationProfileLogoModule } from './logo/logo.module';
import { SettingsOrganizationProfileMainComponent } from './main/main.component';


@NgModule({
    imports: [
        CoreModule,
        CommonModule,
		AppRouterModule,
        FormsModule,
        ReactiveFormsModule,
        OrganizationProfileLogoModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        SettingsOrganizationProfileMainComponent
    ],
    exports: [
		SettingsOrganizationProfileMainComponent
	],

})
export class OrganizationProfileModule { }
